import React from 'react';
import { ADMIN_LEASING_SERVICE_TYPES_READ } from 'constants/rightsCodes';
import LeasingServiceTypeContainer from './LeasingServiceTypeContainer';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = () => {
  return (
    <PermissionCheck authorizationCode={ADMIN_LEASING_SERVICE_TYPES_READ}>
      <LeasingServiceTypeContainer />
    </PermissionCheck>
  );
};

export default Route;
